import { render, staticRenderFns } from "./VvRadio.vue?vue&type=template&id=15c2bc12&scoped=true&"
import script from "./VvRadio.vue?vue&type=script&lang=js&"
export * from "./VvRadio.vue?vue&type=script&lang=js&"
import style0 from "./VvRadio.vue?vue&type=style&index=0&id=15c2bc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2bc12",
  null
  
)

export default component.exports